import { useCallback, useState } from 'react';

export default function useLayouts() {
  const [containerLayout, setContainerLayout] = useState<any>();
  const [itemLayout, setItemLayout] = useState<any>();

  const onLayoutItem = useCallback(
    ({ nativeEvent }: any) => setItemLayout(nativeEvent.layout),
    [setItemLayout],
  );

  const onLayoutContainer = useCallback(
    ({ nativeEvent }: any) => setContainerLayout(nativeEvent.layout),
    [setContainerLayout],
  );

  return { containerLayout, itemLayout, onLayoutContainer, onLayoutItem };
}
